<template>
  <section :class="prefixCls"> <slot></slot> </section>
</template>

<script setup lang="ts">
  import { useDesign } from '/@/hooks/web/useDesign';

  const { prefixCls } = useDesign('container-card-box');
</script>

<style lang="less" scoped>
  @prefix-cls: ~'@{namespace}-container-card-box';

  .@{prefix-cls} {
    background: var(--component-bg-color);
    border-radius: @first-card-radius;
    padding: @first-card-spacing @first-card-spacing 0;
  }
</style>
